<template>
    <img src="img/a.png"/>
</template>
